<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import { useRegisterSW } from 'virtual:pwa-register/vue';
import Toast from '@/components/Toast.vue';

const { t } = useI18n();
const toastId: string = 'general-toast';

const { updateServiceWorker } = useRegisterSW({
  onNeedRefresh() {
    showToast();
  },
});

const showToast = () => {
  toast(Toast, {
    toastId,
    type: 'info',
    theme: toast.THEME.LIGHT,
    autoClose: 10000,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    closeOnClick: false,
    icon: false,
    position: toast.POSITION.BOTTOM_RIGHT,
    expandCustomProps: true,
    contentProps: {
      message: t('app-update.message'),
      button: t('app-update.button'),
      onRefreshPage: () => updateServiceWorker(),
    },
    onClose: () => updateServiceWorker(),
  });
};
</script>

<template>
  <RouterView />
</template>
